import dayjs from 'dayjs';
import { useIdleTimer } from 'react-idle-timer';

import { expirationDateStorage } from '@storage/authStorage';

interface Props {
  onIdle: () => void;
}

export const useSessionTimer = ({ onIdle }: Props) => {
  const timeCheck = dayjs(
    new Date(Number(expirationDateStorage.get()) * 1000)
  ).diff(dayjs(), 'second');

  useIdleTimer({
    timeout: timeCheck < 0 ? 100 : timeCheck * 1000,
    onIdle: onIdle,
  });
};
